<template>
  <pack>
    <zt-title class="mb8">
      轮播图管理
      <zt-button
        type="primary"
        slot="after"
        size="medium"
        class="add-button"
        @click="onAddItemClick"
      >添加</zt-button>
    </zt-title>
    <p class="tip" v-show="list[0] && list[0].id == 0">马上开始设置第一个轮播图吧</p>
    <!-- <draggable :list="list" :options="drawOptions" @change="onSortChange" ref="draggable"> -->
    <!-- <transition-group name="fade-transform" mode="out-in" appear> -->
    <banner-card
      v-for="(o, i) of list"
      :key="o.id"
      v-bind.sync="o"
      :is-first="list[0].id === 0 ? i == 1 : i == 0"
      :is-last="i === list.length - 1"
      :index="i"
      @refresh="onRefreshList"
      @cancel="onCancel"
      @sort-up="onSortUpClick"
      @sort-down="onSortDownClick"
    />
    <!-- </transition-group> -->
    <!-- </draggable> -->
  </pack>
</template>

<script>
import BannerCard from './components/BannerCard';
import {
  admin_cms_banner_recommend_list,
  admin_cms_banner_recommend_order_set
} from '@/api/cmsbanner';
import { formatDate, diffStamp } from '@/utils/date';
// import draggable from 'vuedraggable'
export default {
  name: 'CmsBanner',
  components: {
    BannerCard,
    // draggable
  },
  data: () => ({
    list: [],
  }),

  computed: {
    // drawOptions: () => ({
    //   draggable: '.banner-card',
    //   filter: '.banner-card.new-one',
    //   animation: 150
    // })
  },

  methods: {
    defaultEndTime(time) {
      var _time = new Date(time);
      var _month = _time.getMonth();
      var _year = _time.getFullYear();
      var _day = _time.getDate();
      var _hours = _time.getHours();
      var _minutes = _time.getMinutes();
      var _seconds = _time.getSeconds();
      if (_month == 12) {
        _month = 1;
        _year++;
      } else {
        _month++;
      }
      return new Date(_year, _month, _day, _hours, _minutes, _seconds);
    },
    onAddItemClick() {
      const child = this.list[0];
      if (child && child.id == 0) return;
      this.list.unshift({
        picture: '',
        url: '',
        id: 0,
        add_time: formatDate(new Date()),
      });
    },
    onRefreshList() {
      this.loadList();
    },
    onCancel() {
      this.list.splice(0, 1);
    },

    // 排序按钮点击 上移动
    onSortUpClick({ index }) {
      // this.$refs.draggable.updatePosition(index, index - 1)
      this.updatePosition(index, index - 1);
      this.onSortChange();
    },
    onSortDownClick({ index }) {
      // this.$refs.draggable.updatePosition(index, index + 1)
      if(!this.list[index+1].overdue) {
        this.updatePosition(index, index + 1);
        this.onSortChange();
      }
    },

    // 排序
    onSortChange() {
      // 没有id的元素永远只能放在第一位
      const newItem = this.list.find((o) => o.id == 0);
      if (this.list[0].id !== 0 && newItem) {
        const index = this.list.indexOf(newItem);
        this.sortItem(index, 0);
      }

      let sortId = this.list.map((o) => o.id);
      if (newItem) sortId.splice(0, 1);
      admin_cms_banner_recommend_order_set(sortId.join(','));
    },

    updatePosition(oldIndex, newIndex) {
      this.list.splice(newIndex, 0, this.list.splice(oldIndex, 1)[0]);
    },
    fixList(list) {
      
      let overdueList =[]
      let oldList = list.concat()
      let newList =[]
      let overdueIndex = []
      for(let i=0;i<oldList.length;i++) {
        if(oldList[i].end_time!=undefined) {
          if(diffStamp(oldList[i].end_time)<0) {
            oldList[i].overdue = true
            oldList[i].overTime = Math.abs(diffStamp(oldList[i].end_time))
            overdueList.push(oldList[i])
            overdueIndex.push(oldList[i].id)
          }else{
            oldList[i].overdue = false
          }
        }
      }
      oldList.map((_newList) => {
        if(overdueIndex.indexOf(_newList.id)==-1) {
          newList.push(_newList)
        }
      })
      overdueList.sort(function(a, b) {
        return a.overTime-b.overTime
      })
      return newList.concat(overdueList)
    },
    async loadList() {
      const { data } = await admin_cms_banner_recommend_list({
        type: 'CMS首页推荐',
      });
      if (!data.error_code) {
        this.list=this.fixList(data.list);
        if (data.list.length == 0) {
          this.onAddItemClick();
        }
      } else {
        this.$message.error(data.error_message);
      }
    },
  },

  created() {
    this.loadList();
  },
};
</script>

<style lang="scss" scoped>
.add-button {
  margin-top: 4px;
  width: 96px;
}

.tip {
  color: $theme-textnormal;
  font-size: 14px;
  margin: 12px 0;
}
.min-title{
  margin-bottom: 10px;
}
</style>